module.exports = __webpack_public_path__ + "static/media/teampulse-heart.627dca09.svg";